import React, { useEffect, useState } from 'react';

import useEventTracking from '@hooks/useEventTracking';
import useServerSideRendering from '@hooks/useServerSideRendering';
import { ClickTarget, ContentType, TrackingLocation, click } from '@tracking';
import { articlePathWithParams } from '@utils/queryStringHelper';

import Highlight from '../FeedItems/Highlight';
import TimeAgo from '../TimeAgo';

interface ArticleItemProps {
  highlight: string;
  id: number;
  index: number;
  publishedAt: string;
  slug: string;
  title: string;
  newsletterSlug?: string;
}

const ArticleItem = ({
  highlight,
  id,
  index,
  publishedAt,
  slug,
  title,
  newsletterSlug,
}: ArticleItemProps) => {
  const { Track, trackEvent } = useEventTracking({
    contentId: id,
    contentIndex: index,
    contentType: ContentType.Article,
    location: TrackingLocation.MostPopularArticles,
  });
  const hydrated = useServerSideRendering();
  const [articlePath, setArticlePath] = useState('');

  useEffect(() => {
    if (!hydrated) return;
    setArticlePath(
      articlePathWithParams({
        slug: slug,
        newsletterSlug: newsletterSlug,
      })
    );
  }, [hydrated, slug, newsletterSlug]);

  return (
    <Track>
      <li className="border-0 border-b border-solid border-grayscale-gray py-24 last:border-b-0">
        {highlight && (
          <Highlight highlight={highlight} className="font-suisse-intl-mono !text-caption-sm" />
        )}
        <a
          href={articlePath}
          onClickCapture={() =>
            trackEvent(click({ clickTarget: ClickTarget.Headline, clickText: title }))
          }
          className="my-8 font-suisse-neue text-body-lg text-primary-black hover:text-primary-magenta dark:text-grayscale-charcoal dark:hover:text-primary-pink"
        >
          {title}
        </a>
        {publishedAt && (
          <TimeAgo
            className="block font-suisse-screen text-grayscale-charcoal dark:text-grayscale-gray"
            date={publishedAt}
          />
        )}
      </li>
    </Track>
  );
};

export default ArticleItem;
